import classNames from 'classnames';
import React, { memo, useEffect, useState } from 'react';

import { Icon, Space, Typography } from '@sravni/react-design-system';
import { Message, ThumbUp } from '@sravni/react-icons';
import { OptimizedImg } from '@sravni/ugc/lib/optimizedImgV2';

import { getDate } from '../../../../helpers/news';
import { THighLight } from '../../../../interfaces/news';

import styles from './card.module.scss';

export type TCompressions = 'xl' | 'l' | 'm' | 's' | 'xs' | 't';

interface IProps {
  item: THighLight;
  index: number;
  onClick?: (index: number, item: THighLight) => void;
}

export const Card = memo<IProps>(({ item, index, onClick }) => {
  const { isExternal, url, alias, miniPicture, tags, title, pubDate, commentsCount, likes } = item;

  // const { rubrics } = useDictionaries();

  const [imgCompressions, setImgCompressions] = useState<[TCompressions, TCompressions] | 'auto'>(['m', 'l']);

  useEffect(() => {
    if (window.devicePixelRatio >= 2) setImgCompressions(['l', 'xl']);
  }, []);

  const link = isExternal ? url : `/text/${alias}/`;
  const date = getDate(pubDate);
  // const rubricName = rubrics?.find((el) => el.alias === item.rubric)?.name || '';
  const largeCard = index === 0 || !(index % 4);
  const largeCardRevert = index === 0 || !(index % 8);

  const topInfoBock = (
    <Space className={styles.descriptionInfo} justify={'space-between'} align={'center'}>
      {date}
      <Space justify={'end'} align={'center'} size={8}>
        {commentsCount > 0 ? (
          <div className={styles.infoBlock}>
            <Icon icon={<Message />} size={16} />
            <span>{commentsCount}</span>
          </div>
        ) : null}
        {likes > 0 ? (
          <div className={styles.infoBlock}>
            <Icon icon={<ThumbUp />} size={16} />
            <span>{likes}</span>
          </div>
        ) : null}
      </Space>
    </Space>
  );

  const bottomInfoBlock = (
    <Space className={styles.descriptionInfo} align={'center'} size={12}>
      {/*<Typography.Link className={'h-color-D100'} href={`/mag/rubrika/${rubric}/`}>*/}
      {/*  {rubricName}*/}
      {/*</Typography.Link>*/}
      <Typography.Text className={'h-color-D100'} size={12}>
        {tags[0]}
      </Typography.Text>
    </Space>
  );

  return (
    <Space
      className={classNames(styles.block, largeCard && styles.blockLarge, largeCardRevert && styles.blockLargeRevert)}
      onClick={() => onClick(index, item)}
    >
      <a className={styles.imageWrapper} href={link}>
        {miniPicture ? (
          <OptimizedImg compression={imgCompressions} src={miniPicture} alt={title} className={styles.image} />
        ) : null}
      </a>
      <a className={styles.description} href={link}>
        <div>
          {topInfoBock}
          <Typography.Heading
            level={largeCard ? 3 : 4}
            className={styles.descriptionTitle}
            dangerouslySetInnerHTML={{ __html: title }}
          />
        </div>
        {bottomInfoBlock}
      </a>
    </Space>
  );
});
